<ng-container
  kendoTooltip
  class="tooltip"
  [tooltipWidth]="400"
  filter=".mitre-card"
>
  <div
    class="mitre-card"
    [ngClass]="{
      'companyCoverage': companyTacticTechniqueCoverage,
      'coverage': cyborgTacticTechniqueCoverage,
      'noCoverage': !cyborgTacticTechniqueCoverage
    }"
    [title]="toolTipString"
  >
    <div class="mitre-card-menu-anchor">
      @if (count) {
      <hyperkit-typography
        (click)="menuVisible = true"
        display="inline"
        variant="body"
        color="secondary"
        size="sm"
        align="left"
        color="primary"
      >
        {{ child.name.replace('/', ' ') }}<br />({{ count
        }})</hyperkit-typography
      >
      } @else {
      <hyperkit-typography
        (click)="menuVisible = true"
        display="inline"
        variant="body"
        color="secondary"
        size="sm"
        align="left"
        color="primary"
      >
        {{ child.name.replace('/', ' ') }}</hyperkit-typography
      >
      }

      <hyperkit-dropdown-menu
        position="absolute"
        [isVisible]="menuVisible"
        (closed)="menuVisible = false; subMenuVisible = false"
      >
        <hyperkit-dropdown-menu-item
          label="Apply as filter"
          (itemClick)="onFilter(child.name); menuVisible = false"
        ></hyperkit-dropdown-menu-item>

        @if (sub_techniques_array.length > 0) {
        <hyperkit-dropdown-menu-item
          [label]="subMenuVisible ? 'Sub-techniques ▲' : 'Sub-techniques ▼'"
          (itemClick)="subMenuVisible = !subMenuVisible"
        ></hyperkit-dropdown-menu-item>

        @if (subMenuVisible) { @for (sub of sub_techniques_array; track
        trackByFn($index, sub)) {
        <hyperkit-dropdown-menu-item
          class="mitre-submenu-item"
          [label]="sub.key + ' (' + sub.doc_count + ')'"
          (itemClick)="
            onFilter(sub.key); subMenuVisible = false; menuVisible = false
          "
        ></hyperkit-dropdown-menu-item>
        } } }
      </hyperkit-dropdown-menu>
    </div>
  </div>
</ng-container>
